import React, { useEffect, useState } from 'react'

// eslint-disable-next-line react/display-name
const withRuntime = (WrappedComponent) => (props) => {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  if (!hasMounted) {
    return null
  }

  return <WrappedComponent {...props} />
}

export default withRuntime
